import React from "react";
import "../css/AboutCoreValues.css";

const valuesData = [
  { title: "Accessibility", description: "We strive to make quality healthcare solutions accessible to all, regardless of location or economic status.", color: "blue", icon: "🌍" },
  { title: "Accuracy", description: "We prioritize precision and reliability in our products and services, ensuring trustworthy and actionable health data.", color: "teal", icon: "📊" },
  { title: "Empowerment", description: "We believe in equipping individuals with the knowledge and tools to actively manage their health.", color: "purple", icon: "💪" },
  { title: "Innovation", description: "We are committed to continuous innovation, leveraging cutting-edge technology to advance diagnostic capabilities and digital health solutions.", color: "orange", icon: "🚀" },
  { title: "Integrity", description: "We uphold the highest ethical standards in our research, development, and business practices, building trust with our customers and partners.", color: "red", icon: "🔒" },
  { title: "Personalization", description: "We recognize the uniqueness of each individual's health journey and are dedicated to providing personalized insights and interventions.", color: "green", icon: "🎯" },
  // { title: "Proactivity", description: "We champion a proactive approach to health management, encouraging early detection and preventive care.", color: "gray", icon: "⏳" }
];

const CoreValues = () => {
  return (
    <div className="core-values-container9">
      <h2 className="core-values-heading">Our Core Values</h2>
      <div className="core-values-grid">
        {valuesData.map((item, index) => (
          <div key={index} className={`core-values-card bg-${item.color}`}>
            <div className="core-values-icon">{item.icon}</div>
            <h3 className="core-values-title">{item.title}</h3>
            <p className="core-values-description">{item.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CoreValues;
